module.exports = __webpack_public_path__ + "img/Skirt-Front-B1-Da-Fc-Ga-Hb-Ia.d75227fa.png";